angular.module('invoice')
    .component('invoiceBgt', {
        bindings: {
            invoiceId: '<',
            invoice: '<',
            invoicePricing: '<',
            onDataLoaded: '&?',
        },
        templateUrl: 'app/invoice/bgt/invoice-bgt.html',
        controller: function ($scope, InvoiceConst, InvoiceService, InvoiceBgt, InvoiceBgtService, Principal, BgtGroupingService) {
            this.InvoiceBgtService = InvoiceBgtService
            this.InvoiceService = InvoiceService

            this.$onChanges = () => {
                // this.items = []
                // this.processGrouped()
                InvoiceBgt.query({entityId: this.invoiceId}).$promise.then(result => {
                    this.items = result;
                    this.onDataLoaded({$count: result.length});
                    this.processGrouped();
                })
                Principal.currentUser().then(user => {
                    this.canEditInvoiceBgt = Principal.hasAnyAuthority(['ROLE_INVOICE_DOCUMENTS_BGT_WRITE_WITH_READ_ACCESS', 'ROLE_ADMIN'])
                        || (Principal.hasAnyAuthority(['ROLE_INVOICE_DOCUMENTS_BGT_WRITE', 'ROLE_ADMIN']) && this.canWriteInvoice(user))
                })
            }

            this.canWriteInvoice = user => {
                let isWorker = this.invoice && this.invoice.worker && user && this.invoice.worker.id === user.id
                let isAccountant = Principal.hasAnyAuthority(['ROLE_INVOICE_DOCUMENTS_ACCOUNTING'])
                let isManager = Principal.hasAnyAuthority(['ROLE_INVOICE_DOCUMENTS_ALL'])
                return isWorker || isAccountant || isManager
            }

            this.add = () => {
                // InvoiceBgtService.add(this.totalLeft, this.invoicePricing.totalNet).then(result => {
                //     this.items.push(result);
                //     this.processGrouped();
                // })
                InvoiceBgtService.add(this.invoiceId, this.totalLeft, this.invoicePricing.totalNet, this.invoice.currency).then(() => this.$onChanges())
            }

            // this.edit = (item) => {
            //     let $index = this.items.indexOf(item);
            //     InvoiceBgtService.edit(item, this.totalLeft, this.invoicePricing.totalNet).then(result => {
            //         this.items[$index] = result;
            //         this.processGrouped();
            //     })
            // }
            this.edit = (item) => {
                InvoiceBgtService.edit(this.invoiceId, item, this.totalLeft, this.invoicePricing.totalNet, this.invoice.currency).then(() => this.$onChanges())
            }

            // this.delete = (item) => {
            //     modals.confirmDelete("wybraną pozycję", () => {
            //         let $index = this.items.indexOf(item);
            //         if ($index > -1) {
            //             this.items.splice($index, 1);
            //             this.processGrouped();
            //         }
            //     })
            // }
            this.delete = (item) => {
                InvoiceBgtService.delete(this.invoiceId, item).then(() => this.$onChanges())
            }

            this.getGroupTotal = (grouped) => {
                return BgtGroupingService.sumGroupAmounts(grouped);
            }

            this.processGrouped = () => {
                this.groupedItems = BgtGroupingService.groupItemsByParent(this.items);
                this.total = BgtGroupingService.sumAmounts(this.items);
                this.totalLeft = InvoiceService.sub(this.invoicePricing.totalNet, this.total);
            };

            $scope.$on(InvoiceConst.eventUpdate, () => this.$onChanges())
        }
    })
